import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../Contexts/AuthContext";
import axios from "axios";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import loader from "../assets/loading.gif";
import Navbar from "../Components/Navbar";

const Login = ({ }) => {
  const [searchParams] = useSearchParams();
  const { setUser, user } = useAuthContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [Vloading, setVLoading] = useState(false);
  const [vermodal, setvermodal] = useState(false);
  const [vermsg, setvrmessage] = useState("");

  const [credentials, setCredentials] = useState({});
  const { id } = useParams();

  const Check = async () => {
    setVLoading(true);
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BASE_URL + `/api/auth/verify/${id}`
      );
      setvrmessage(data);
      setvermodal(true);
      setVLoading(false);
    } catch (err) {
      setVLoading(false);
      setvermodal(false);
      toast.error(err.response?.data.error, {
        position: "top-center",
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      Check();
    }
  }, [id]);

  const HandleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/auth/login",
        {
          ...credentials,
          email: credentials.email.toLowerCase(),
        }
      );
      if (data.success) {
        setUser(jwt_decode(data.authToken));
        Cookies.set("token", data.authToken, { expires: 3, secure: true });
        searchParams.get("callback") === "verify"
          ? navigate(`/${searchParams.get("callback")}`)
          : navigate("/");
      }
      setLoading(false);
    } catch (err) {
      toast.error(
        err.response?.data.msg ? err.response?.data.msg : "Please fill all fields!",
        {
          position: "top-center",
          theme: "dark",
        }
      );
      console.log(err);
      setLoading(false);
    }
  };

  const HandleChange = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  if (user) return <Navigate to={"/"} />;
  if (Vloading) return <img src={loader} alt="loading..." className="loader" />;

  return (
    <>
      <style>{`
        .wv-login {
          /* --- brand accent (Walletven red). Change here if the exact hex differs --- */
          --accent: #F6394F;
          --accent-strong: #e22440;

          --ink: #101828;
          --muted: #667085;
          --label: #475467;
          --field: #f5f6f8;
          --field-border: #ececf0;
          --card-border: #ececec;

          min-height: 100vh;
          background: #ffffff;
          color: var(--ink);
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 96px 20px 72px;
          box-sizing: border-box;
        }

        .wv-login * { box-sizing: border-box; }

        .wv-login .wv-card {
          width: 100%;
          max-width: 760px;
          background: #ffffff;
          border: 1px solid var(--card-border);
          border-radius: 20px;
          padding: 44px;
          box-shadow: 0 12px 44px rgba(16, 24, 40, 0.06);
        }

        .wv-login h1 {
          margin: 0 0 12px;
          font-size: 2rem;
          font-weight: 800;
          letter-spacing: -0.02em;
          color: #0f1620;
        }

        .wv-login .wv-sub {
          margin: 15px 0px;
          color: var(--muted);
          font-size: 1.02rem;
          line-height: 1.55;
        }

        .wv-login .wv-field { margin-bottom: 20px; }

        .wv-login .wv-field label {
          display: block;
          margin-bottom: 8px;
          color: var(--label);
          font-weight: 600;
          font-size: 0.95rem;
        }

        .wv-login .wv-input {
          width: 100%;
          background: var(--field);
          border: 1px solid var(--field-border);
          border-radius: 11px;
          padding: 15px 16px;
          font-size: 1rem;
          color: var(--ink);
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
        }

        .wv-login .wv-input::placeholder { color: #98a2b3; }

        .wv-login .wv-input:focus {
          background: #ffffff;
          border-color: var(--accent);
          box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.14);
        }

        .wv-login .wv-forgot {
          display: block;
          text-align: right;
          margin-top: 8px;
          font-size: 0.85rem;
          color: var(--accent);
          text-decoration: none;
        }
        .wv-login .wv-forgot:hover { text-decoration: underline; }

        .wv-login .wv-submit {
          width: 100%;
          margin-top: 8px;
          padding: 16px;
          background: var(--accent);
          color: #ffffff;
          font-weight: 700;
          font-size: 1rem;
          border: none;
          border-radius: 11px;
          cursor: pointer;
          transition: background 0.15s ease, transform 0.05s ease;
        }

        .wv-login .wv-submit:hover:not(:disabled) { background: var(--accent-strong); }
        .wv-login .wv-submit:active:not(:disabled) { transform: translateY(1px); }
        .wv-login .wv-submit:disabled { opacity: 0.6; cursor: not-allowed; }

        .wv-login .wv-switch {
          text-align: center;
          margin-top: 18px;
          font-size: 0.9rem;
          color: var(--muted);
        }
        .wv-login .wv-switch a { color: var(--accent); text-decoration: none; }
        .wv-login .wv-switch a:hover { text-decoration: underline; }

        /* --- verification modal (light, matches the card) --- */
        .wv-login .wv-modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(16, 24, 40, 0.45);
          z-index: 200000;
        }
        .wv-login .wv-modal {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          z-index: 200001;
        }
        .wv-login .wv-modal-card {
          width: 100%;
          max-width: 440px;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 24px 60px rgba(16, 24, 40, 0.25);
          overflow: hidden;
        }
        .wv-login .wv-modal-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 24px;
          border-bottom: 1px solid #f0f1f4;
        }
        .wv-login .wv-modal-head h2 {
          margin: 0;
          font-size: 1.15rem;
          font-weight: 700;
          color: var(--ink);
        }
        .wv-login .wv-modal-close {
          background: none;
          border: none;
          font-size: 1.4rem;
          line-height: 1;
          color: #98a2b3;
          cursor: pointer;
          padding: 4px;
        }
        .wv-login .wv-modal-close:hover { color: var(--ink); }
        .wv-login .wv-modal-body {
          padding: 24px;
          color: var(--muted);
          font-size: 0.98rem;
          line-height: 1.55;
        }
        .wv-login .wv-modal-foot {
          display: flex;
          justify-content: flex-end;
          padding: 16px 24px;
          border-top: 1px solid #f0f1f4;
        }
        .wv-login .wv-modal-ok {
          padding: 11px 24px;
          background: var(--accent);
          color: #ffffff;
          font-weight: 600;
          border: none;
          border-radius: 9px;
          cursor: pointer;
          transition: background 0.15s ease;
        }
        .wv-login .wv-modal-ok:hover { background: var(--accent-strong); }

        @media (max-width: 480px) {
          .wv-login { padding: 84px 16px 48px; }
          .wv-login .wv-card { padding: 28px; border-radius: 16px; }
          .wv-login h1 { font-size: 1.7rem; }
        }
      `}</style>

      <Navbar />
      <div className="wv-login">
        <ToastContainer />

        <form className="wv-card" onSubmit={HandleLogin}>
          <h1>Inicia sesión</h1>
          <p className="wv-sub">Accede a tu Cuenta para gestionar tus envíos.</p>

          <div className="wv-field" style={{marginTop: "15px"}}>
            <label htmlFor="email">Correo</label>
            <input
              type="email"
              className="wv-input"
              id="email"
              aria-describedby="emailHelp"
              placeholder="tucorreo@ejemplo.com"
              onChange={(e) => HandleChange(e)}
            />
          </div>

          <div className="wv-field">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              className="wv-input"
              id="password"
              placeholder="Tu contraseña"
              onChange={(e) => HandleChange(e)}
            />
            <Link to={"/forgotpassword"} className="wv-forgot">
              Recuperar Contraseña
            </Link>
          </div>

          <button type="submit" className="wv-submit" disabled={loading}>
            {loading ? "Enviando" : "Acceder"}
          </button>

          <p className="wv-switch">
            ¿No tienes cuenta?{" "}
            <Link to="/registro">Regístrate ahora</Link>
          </p>
        </form>

        {vermodal && (
          <>
            <div className="wv-modal-backdrop" onClick={() => setvermodal(false)}></div>
            <div className="wv-modal">
              <div className="wv-modal-card">
                <div className="wv-modal-head">
                  <h2>Aviso</h2>
                  <button
                    type="button"
                    className="wv-modal-close"
                    aria-label="Cerrar"
                    onClick={() => setvermodal(false)}
                  >
                    &times;
                  </button>
                </div>
                <div className="wv-modal-body">{vermsg}</div>
                <div className="wv-modal-foot">
                  <button
                    type="button"
                    className="wv-modal-ok"
                    onClick={() => setvermodal(false)}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Login;